import React, {useEffect, useState} from "react";
import axios from "axios";
import {Route, Routes} from "react-router-dom";
import {header} from "../Components/Url/ApiUrl";
import './Pages.css'
import Leftbar from "../Components/Leftbar/Leftbar";
import Navigation from "../Components/Navigation/Navigation";
import HeadInfo from "../Components/Head/HeadInfo";
import Company from "./company/Company";
import CompanyHead from "./companyHead/CompanyHead";
import OperationArea from "./operationArea/OperationArea";
import CompanyPower from "./companyPower/CompanyPower";
import CompanyDocuments from "./companyDocuments/CompanyDocuments";
import CompanyServices from "./companyServices/CompanyServices";
import Complaints from "./complaints/Complaints";
import ErrorBoundary from "../Components/ErrorBoundary/ErrorBoundary";
const Pages = () => {
    const [maxmenu, setMaxmenu] = useState(true);

    const [user, setUser] = useState({});
    const [regions, setRegions] = useState([]);

    const fetchUser = async () => {
        const data = await axios
            .get(process.env.REACT_APP_API_ENDPOINT+"/company/getme",{headers:header})
            .catch((err) => {
                console.log("Error",err);
            });
        if(data){
            setUser(data?.data?.user);
            setRegions(data?.data?.regions);
        }
    }
    useEffect(() => {
        fetchUser()
    },[]);

    return (
        <div className="App container-fluid">
            <div className={maxmenu ? "row" : "row close"} id="wrapper">
                <ErrorBoundary>
                    <Leftbar/>
                </ErrorBoundary>
                <div className="col right-bar p-0">
                    <ErrorBoundary>
                        <Navigation maxmenu={maxmenu} setMaxmenu={setMaxmenu} user={user}/>
                    </ErrorBoundary>
                    <div className="container-fluid">
                        <div className="row">
                            <HeadInfo user={user} setUser={setUser}/>
                            <div className="col px-5 pb-5">
                                <Routes>
                                    <Route path="company" element={<ErrorBoundary><Company regions={regions} user={user}/></ErrorBoundary>}></Route>
                                    <Route path="company-head" element={<ErrorBoundary><CompanyHead user={user}/></ErrorBoundary>}></Route>
                                    <Route path="operation-area" element={<ErrorBoundary><OperationArea regions={regions} user={user}/></ErrorBoundary>}></Route>
                                    <Route path="company-power" element={<ErrorBoundary><CompanyPower user={user}/></ErrorBoundary>}></Route>
                                    <Route path="company-documents" element={<ErrorBoundary><CompanyDocuments user={user}/></ErrorBoundary>}></Route>
                                    <Route path="company-services" element={<ErrorBoundary><CompanyServices user={user} regions={regions}/></ErrorBoundary>}></Route>
                                    <Route path="complaints" element={<ErrorBoundary><Complaints user={user}/></ErrorBoundary>}></Route>
                                    <Route path="*" element={<ErrorBoundary><Company user={user}/></ErrorBoundary>}></Route>
                                </Routes>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Pages;